module.exports = __webpack_public_path__ + "img/next-arrow.c741b122.svg";